import React from 'react';
import { Renovation } from '@search/filter-enums/enums/Renovation';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { RenovationFilter } from '../../../models/Filter';

interface IRenovationNewFilter {
    filter: RenovationFilter;
    handleChange: (value: RenovationFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<Renovation>[] = [
    { label: 'Косметический', value: Renovation.COSMETIC },
    { label: 'Дизайнерский', value: Renovation.DESIGNED },
    { label: 'Евро', value: Renovation.EURO },
    { label: 'Нужен ремонт', value: Renovation.NEED },
];

export const RenovationNewFilter: React.FC<IRenovationNewFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, optionType: Renovation) => {
        const filters = new Set(filter.value);

        filters[value ? 'add' : 'delete'](optionType);
        handleChange(new RenovationFilter(Array.from(filters)));
    }, [ handleChange, filter.value ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ label, value }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter.value.includes(value)}
                        onChange={v => onChange(v, value)}
                        dataTest='renovation'
                        variant='filter'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
